const STORAGE_KEY = 'ipe_sms_send_cooldown';
const DEFAULT_COOLDOWN_SECONDS = 60;

function buildKey(phone, scene) {
  return `${String(scene || '').trim()}:${String(phone || '').trim()}`;
}

function readStore() {
  try {
    const raw = sessionStorage.getItem(STORAGE_KEY);
    if (!raw) return {};
    const data = JSON.parse(raw);
    return data && typeof data === 'object' ? data : {};
  } catch {
    return {};
  }
}

function writeStore(data) {
  try {
    sessionStorage.setItem(STORAGE_KEY, JSON.stringify(data));
  } catch {
    // ignore quota / private mode
  }
}

export function getSmsSendCooldownRemaining(phone, scene) {
  const key = buildKey(phone, scene);
  if (!key || key === ':') return 0;
  const entry = readStore()[key];
  if (!entry?.expiresAt) return 0;
  const remaining = Math.ceil((entry.expiresAt - Date.now()) / 1000);
  if (remaining <= 0) return 0;
  // 历史版本曾把发码锁剩余秒数写入 session；仅保留正常发码短冷却
  if (remaining > DEFAULT_COOLDOWN_SECONDS) return 0;
  return remaining;
}

export function setSmsSendCooldown(phone, scene, seconds = DEFAULT_COOLDOWN_SECONDS) {
  const key = buildKey(phone, scene);
  if (!key || key === ':') return;
  const safeSeconds = Math.max(1, Number(seconds) || DEFAULT_COOLDOWN_SECONDS);
  const data = readStore();
  data[key] = { expiresAt: Date.now() + safeSeconds * 1000 };
  writeStore(data);
}

export { DEFAULT_COOLDOWN_SECONDS };
